import React from 'react';
import NemCtrl from './NemCtrl.js';
import { Platform } from 'react-native';
import browser from 'detect-browser';

const constants = {
  colorRed: '#d62631',
  colorWhite: '#ffffff',
  colorGray: '#dedede',
};

export default class RothSelect extends NemCtrl {
  style = {
    default: {
      width: '60%',
      textAlign: 'center',
      textAlignLast: 'center',
      padding: '0px',
      boxSizing: 'border-box',
      fontSize: '16px',
      fontWeight: '400',
      height: '42px',
      margin: '7px 0px',
      border: '2px solid black',
      borderRadius:
        browser.name === 'ie' ||
        browser.name === 'edge' ||
        browser.name === 'fxios' ||
        browser.name === 'crios' ||
        browser.name === 'ios' ||
        Platform.OS === 'ios' ||
        Platform.OS === 'iosweb'
          ? '0px'
          : '22px',
      background: constants.colorWhite,
      color: constants.colorRed,
      fontFamily: "'Molengo', sans-serif",
      display: 'inline-block',
    },
  };
  optionStyle = {
    textAlign: 'center',
    background: 'transparent',
  };
  handleChange = event => {
    if ('fn' in this.props) {
      if ('param' in this.props && 'value' in this.props) this.props.fn(this.props.param, event.target.value);
      else if ('param' in this.props) this.props.fn(this.props.param);
      else if ('value' in this.props) this.props.fn(event.target.value);
      else this.props.fn();
    }
  };
  renderOptions = () => {
    var _this = this;
    return Object.keys(_this.props.options).map(function(option) {
      return (
        <option style={_this.optionStyle} key={option} value={option}>
          &nbsp;&nbsp;&nbsp;{_this.props.options[option]}
        </option>
      );
    });
  };
  render = () => {
    console.log(browser.name);
    console.log(Platform.OS);
    var select = (
      <select
        style={Object.assign(
          {},
          this.getStyle(),
          this.props.disabled ? { opacity: 0.5, cursor: 'default', backgroundColor: 'gray', color: 'black' } : {}
        )}
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.handleChange}
      >
        {this.renderOptions()}
      </select>
    );
    return this.props.children !== undefined ? (
      <label style={{ display: 'block', verticalAlign: 'middle', width: '100%' }}>
        <div
          style={{ width: '36%', paddingRight: '10px', display: 'inline-block' }}
          className={this.props.mobileHideLabel === true ? 'mobilehide' : 'mobileshow'}
        >
          {this.props.children}
        </div>{' '}
        {select}
      </label>
    ) : (
      <label>(select)</label>
    );
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/RothSelect.js
 **/